module.exports = __webpack_public_path__ + "static/media/izlozba (15).0e4ef5e3.jpg";